import { addOneHour } from "@/shared/lib/date-time";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  ScrollArea,
} from "@devhop/ui";
import { format } from "date-fns";
import { useCreateClassSession } from "../api/queries";
import { ClassSessionForm } from "./ClassSessionForm";

function toTimeHHmm(s: string | undefined): string {
  if (!s) return "09:00";
  if (s.length >= 8) return s.slice(0, 5);
  return s;
}

type CreateSessionDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialDate?: string;
  initialStartTime?: string;
  initialEndTime?: string;
  onSuccess?: () => void;
};

export function CreateSessionDialog({
  open,
  onOpenChange,
  initialDate,
  initialStartTime,
  initialEndTime,
  onSuccess,
}: CreateSessionDialogProps) {
  const createSession = useCreateClassSession();

  const initialValues = {
    templateId: "",
    date: initialDate ?? format(new Date(), "yyyy-MM-dd"),
    startTime: toTimeHHmm(initialStartTime) ?? "09:00",
    endTime:
      toTimeHHmm(initialEndTime) ||
      (initialStartTime ? addOneHour(toTimeHHmm(initialStartTime)) : ""),
    roomId: "",
    leadInstructorId: "",
    assistInstructorIds: [] as string[],
    capacity: 20,
    notes: "",
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className="!max-w-[min(95vw,1200px)] max-h-[90vh] overflow-hidden p-0"
          showCloseButton
        >
          <DialogHeader className="border-b px-6 py-4">
            <DialogTitle>ສ້າງ ຊົ່ວໂມງຮຽນ</DialogTitle>
          </DialogHeader>
          <ScrollArea className="max-h-[calc(90vh-4rem)] overflow-auto px-6 pb-6">
            <ClassSessionForm
              key={
                open
                  ? `${initialDate ?? ""}-${initialStartTime ?? ""}-${initialEndTime ?? ""}`
                  : "closed"
              }
              initialValues={initialValues}
              onSubmit={async (values) => {
                const { changeReason, ...payload } = values;
                void changeReason;
                try {
                  await createSession.mutateAsync(payload);
                  onSuccess?.();
                  onOpenChange(false);
                } catch {
                  // Error handled by mutation
                }
              }}
              submitting={createSession.isPending}
              onCancel={() => onOpenChange(false)}
            />
          </ScrollArea>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
